//Components
import ContactForm from '../../components/Contact/ContactForm'
import Socials from '../../components/Socials'

//SCSS VARIABLES
import configVariables from '../../assets/sass/variables/config.module.scss'

//Intersection
import { useInView } from 'react-intersection-observer'

import Translate from '../../i18n/Translate'

const ContactInfo = () => {
    const { colorClaro, colorSecundario } = configVariables

    const [contactTitle, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    const [info, inView2] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    })

    const [sedes, inView3] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    })

    const [socials, inView4] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    })

    return (
        <section className="incoming-contact__info">
            <h2 className={`form-title animate slide-up ${inView ? 'in-view' : ''}`} ref={contactTitle}>
                <Translate langkey="contact.form.title" />
            </h2>

            <div className="container">
                <ContactForm />

                <div className="container-2">
                    <div className={`social-media-icons animate slide-right ${inView4 ? 'in-view' : ''}`} ref={socials}>
                        <Socials
                            fill={colorClaro}
                            background={colorSecundario}
                            socials={['facebook', 'instagram', 'twitter', 'youtube', 'linkedin']}
                        />
                    </div>
                    <div className={`contact-info animate slide-up ${inView2 ? 'in-view' : ''}`} ref={info}>
                        <h3>
                            <Translate langkey="contact.info.title" />
                        </h3>
                        <p>
                            <Translate langkey="contact.info.address" />
                        </p>
                        <h3>
                            <Translate langkey="contact.info.title2" />
                        </h3>
                        <p>
                            <Translate langkey="contact.info.phone" />
                        </p>
                        <h3>
                            <Translate langkey="contact.info.title3" />
                        </h3>
                        <p>
                            <Translate langkey="contact.info.email" />
                        </p>
                    </div>
                </div>

                <div className={`sedes animate slide-up ${inView3 ? 'in-view' : ''}`} ref={sedes}>
                    <h3>
                        <Translate langkey="contact.locations.title" />
                    </h3>
                    <h4>
                        <Translate langkey="contact.locations.location1" />
                    </h4>
                    <p>
                        <Translate langkey="contact.locations.email1" />
                    </p>
                    <h4>
                        <Translate langkey="contact.locations.location2" />
                    </h4>
                    <p>
                        <Translate langkey="contact.locations.email2" />
                    </p>
                    <h4>
                        <Translate langkey="contact.locations.location3" />
                    </h4>
                    <p>
                        <Translate langkey="contact.locations.email3" />
                    </p>
                    <h4>
                        <Translate langkey="contact.locations.location4" />
                    </h4>
                    <p>
                        <Translate langkey="contact.locations.email4" />
                    </p>
                    <h4>
                        <Translate langkey="contact.locations.location5" />
                    </h4>
                    <p>
                        <Translate langkey="contact.locations.email5" />
                    </p>
                    <h4>
                        <Translate langkey="contact.locations.location6" />
                    </h4>
                    <p>
                        <Translate langkey="contact.locations.email6" />
                    </p>
                </div>
            </div>
        </section>
    )
}

export default ContactInfo
